export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
          联系我们
        </h2>
        <p className="text-foreground-600 mb-8 text-sm md:text-base">
          有爆料线索？想投稿合作？欢迎通过以下方式联系我们
        </p>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a href="#about" className="inline-flex items-center gap-2 whitespace-nowrap bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer">
              <i className="ri-mail-send-line"></i>投稿爆料
            </a>
            <a href="#about" className="inline-flex items-center gap-2 whitespace-nowrap bg-secondary-100 text-secondary-700 px-6 py-3 rounded-full text-sm font-medium hover:bg-secondary-200 transition-colors duration-200 cursor-pointer">
              <i className="ri-chat-smile-2-line"></i>商务合作
            </a>
          </div>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
              tips@mrdsdaily.com
            </span>
            <span className="hidden sm:block text-foreground-300">|</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-wechat-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
              mrds_official
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}